import { render, staticRenderFns } from "./ItemPickerNoData.vue?vue&type=template&id=10d89062&scoped=true&"
import script from "./ItemPickerNoData.vue?vue&type=script&lang=js&"
export * from "./ItemPickerNoData.vue?vue&type=script&lang=js&"
import style0 from "./ItemPickerNoData.vue?vue&type=style&index=0&id=10d89062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d89062",
  null
  
)

export default component.exports